import { Price } from 'src/features/pricing/components/price';
import styled from 'styled-components';

export const StyledMessage = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  padding: 0rem;
  padding-top: 0.8rem;
  text-align: center;

  @media screen and (min-width: 576px) {
    text-align: left;
  }
`;

export const StyledOldPrice = styled(Price)`
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  text-decoration: line-through;
`;

export const StyledPrice = styled.span`
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const StyledBlock = styled.div`
  display: inline-block;
`;
